import { FC } from 'react';

import { ProjectManagementList } from './project-management-list';

export const ProjectManagementPage: FC = () => {
  return <ProjectManagementList />;
};
